import { useCallback } from "react";
import { useError } from "../../context/errorContext";

const useCardReader = () => {
    const { showMessage } = useError();

    const readCard = useCallback(async () => {
        let device;

        try {
            if (!navigator.usb) {
                throw new Error(
                    "WebUSB wird von diesem Browser nicht unterstützt."
                );
            }

            // USB-Gerät auswählen
            device = await navigator.usb.requestDevice({
                filters: []
            });

            await device.open();

            if (device.configuration === null) {
                await device.selectConfiguration(1);
            }

            // USB-Schnittstelle auswählen
            const interfaceNumber =
                device.configuration.interfaces[0].interfaceNumber;

            await device.claimInterface(interfaceNumber);

            // Hier müssen die passenden USB-Transfers
            // für deinen RFID-Reader implementiert werden.

            return null;

        } catch (error) {
            if (error?.name === "NotFoundError") {
                return null;
            }

            showMessage(
                error?.message || "RFID-Reader konnte nicht gelesen werden."
            );

            return null;

        } finally {
            if (device?.opened) {
                try {
                    await device.close();
                } catch (error) {
                    console.error("USB-Gerät konnte nicht geschlossen werden:", error);
                }
            }
        }
    }, [showMessage]);

    return { readCard };
};

export default useCardReader;